import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../common/html/checkbox'
import {
  changeCheckedProfileIds,
  selectCheckedProfileIds,
  selectProfileById,
} from '../store/slice'

export const CheckboxCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const isDefaultProfile = useSelector(
    selectProfileById(rowId, 'isDefaultProfile'),
  )
  const checked = useSelector(selectCheckedProfileIds(rowId))
  const isDisabled = useSelector(selectProfileById(rowId, 'disabled'))

  const onChange = (isCheck) => {
    dispatch(changeCheckedProfileIds({ [rowId]: isCheck }))
  }

  return isDefaultProfile || isDisabled ? null : (
    <Checkbox checked={checked} onChange={onChange} />
  )
}
